(function () {
  function buildCartTitle(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return 'Cart Procurement Run';
    }

    if (cart.items.length === 1) {
      return 'Cart · ' + cart.items[0].product_title;
    }

    return 'Cart Procurement Run · ' + cart.items.length + ' items';
  }



  function buildCartItemsSummary(cart) {
    if (!cart || !cart.items || !cart.items.length) return '';

    return cart.items.map(function (item) {
      return [
        item.product_title || '',
        'x' + (item.quantity || 0),
        '-',
        '₱' + (((item.final_line_price || 0) / 100).toLocaleString('en-PH'))
      ].join(' ');
    }).join(' | ');
  }

function hasRegularCart(cart) {
  if (!cart || !cart.items) return false;

  return cart.items.some(function (item) {
    var tags = Array.isArray(item.tags)
      ? item.tags.map(function (t) { return String(t).toLowerCase(); })
      : String(item.tags || '')
          .toLowerCase()
          .split(',')
          .map(function (t) { return t.trim(); })
          .filter(Boolean);

    var productType = String(item.product_type || '').toLowerCase();
    var handle = String(item.handle || '').toLowerCase();
    var title = String(item.product_title || '').toLowerCase();
    var url = String(item.url || '').toLowerCase();

    var isVehicle =
      productType === 'vehicle_rent' ||
      tags.includes('vehicle_rent') ||
      handle.includes('koop-king') ||
      title.includes('toyota hiace') ||
      title.includes('grandia') ||
      url.includes('koop-king');

    var isVpi =
      productType === 'vpi' ||
      tags.includes('vpi') ||
      handle.includes('verification') ||
      title.includes('verification') ||
      title.includes('vin') ||
      url.includes('verification');

    return !isVehicle && !isVpi;
  });
}


function hasVpiCart(cart) {
  if (!cart || !cart.items) return false;

  return cart.items.some(function (item) {
    var tags = Array.isArray(item.tags)
      ? item.tags.map(function (t) { return String(t).toLowerCase(); })
      : [];

    var productType = String(item.product_type || '').toLowerCase();
    var handle = String(item.handle || '').toLowerCase();
    var title = String(item.product_title || '').toLowerCase();

    return productType === 'vpi' ||
           tags.includes('vpi') ||
           handle.includes('verification') ||
           title.includes('verification') ||
           title.includes('vin');
  });
}

function hasVehicleCart(cart) {
  if (!cart || !cart.items) return false;

  return cart.items.some(function (item) {
    var tags = Array.isArray(item.tags)
      ? item.tags.map(function (t) { return String(t).toLowerCase(); })
      : [];

    var productType = String(item.product_type || '').toLowerCase();
    var handle = String(item.handle || '').toLowerCase();
    var title = String(item.product_title || '').toLowerCase();

    return productType === 'vehicle_rent' ||
           tags.includes('vehicle_rent') ||
           handle.includes('koop-king') ||
           title.includes('toyota hiace') ||
           title.includes('grandia');
  });
}

  
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-quickpay]');
    if (!trigger) return;

    event.preventDefault();

    if (trigger.getAttribute('data-cart-quickpay-enabled') !== 'true') {
      return;
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        if ((cart.total_price || 0) < 2000000) return;

        trigger.dataset.productId = 'cart';
        trigger.dataset.productTitle = buildCartTitle(cart);
        trigger.dataset.productHandle = 'cart-procurement';
        trigger.dataset.productVendor = 'BuyCoop';
        trigger.dataset.productPrice = String((cart.total_price || 0) / 100);
        trigger.dataset.productTags = 'cart,procurement';
        trigger.dataset.cooppayDestination = '';
        trigger.dataset.lightningDestination = '';

        trigger.dataset.cartMode = 'true';
       trigger.dataset.cartHasVpi = hasVpiCart(cart) ? 'true' : 'false';
trigger.dataset.cartHasVehicle = hasVehicleCart(cart) ? 'true' : 'false';
        trigger.dataset.cartHasRegular = hasRegularCart(cart) ? 'true' : 'false';
        trigger.dataset.cartToken = cart.token || '';
        trigger.dataset.cartItemCount = String(cart.item_count || 0);
        trigger.dataset.cartTotal = String((cart.total_price || 0) / 100);
        trigger.dataset.cartItemsSummary = JSON.stringify(
  cart.items.map(function(item) {
    return {
      title: item.product_title || '',
      qty: item.quantity || 0,
      price: ((item.final_line_price || 0) / 100)
    };
  })
);

        if (typeof openCoopQRModal === 'function') {
          openCoopQRModal(trigger);
        } else {
          console.error('openCoopQRModal is not available');
        }
      })
      .catch(function (err) {
        console.error('cart-quickpay.js error:', err);
      });
  });
})();